// import logo from './logo.svg';
import './App.scss';
import Home from './components/home/Home';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
